import React from 'react';
import CalendarBox from './CalendarBox';
import { Container, Title, CdAtivo } from './styles';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';

const GestaoAgendamento: React.FC = () => {
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);

  return (
    <Container>
      <Title className="themeTitleConsultaAgendamento">Consulta de agendamento</Title>
      <CdAtivo className="cdConsultaAgendamento">CD: {cddAtivo?.nomeFantasia} </CdAtivo>

      <CalendarBox />
    </Container>
  );
};

export default GestaoAgendamento;
